module.exports = new __parcel__URL__("goblin-king.3397b392.webp").toString();